<template>
  <section class="finances-summary">
    <div class="finances-summary__item">
      <span class="finances-summary__title">
        Despesas
      </span>

      <transition name="fade">
        <span
          v-if="!loading"
          class="finances-summary__value finances-summary__value--expenses"
        >
          R$ {{ balance.expenses | TO_BRL }}
        </span>
      </transition>

      <dr-loader
        v-if="loading"
        class="finances-summary__loader"
      />
    </div>

    <div class="finances-summary__item">
      <span class="finances-summary__title">
        Receita prevista
      </span>

      <transition name="fade">
        <span
          v-if="!loading"
          class="finances-summary__value finances-summary__value--foreseen"
        >
          R$ {{ balance.foreseen | TO_BRL }}
        </span>
      </transition>

      <dr-loader
        v-if="loading"
        class="finances-summary__loader"
      />
    </div>

    <div class="finances-summary__item">
      <span class="finances-summary__title">
        Receita realizada
      </span>

      <transition name="fade">
        <span
          v-if="!loading"
          class="finances-summary__value finances-summary__value--revenue"
        >
          R$ {{ balance.revenue | TO_BRL }}
        </span>
      </transition>

      <dr-loader
        v-if="loading"
        class="finances-summary__loader"
      />
    </div>
  </section>
</template>

<script>
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'financesSummary',

  data () {
    return {
      loading: false,
      balance: {
        expenses: 0,
        foreseen: 0,
        revenue: 0
      },
      filters: {
        startDate: null,
        endDate: null
      }
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    prefix () {
      return `/${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor_office/${this.office.id}`
    },

    sufix () {
      const startDate = this.$moment(this.filters.startDate).format('YYYY-MM-DD')
      const endDate = this.$moment(this.filters.endDate).format('YYYY-MM-DD')

      return `initialDate=${startDate}&finalDate=${endDate}&filterNot[fs.status]=CANCELADO`
    }
  },

  watch: {
    'filters.startDate': {
      immediate: false,
      deep: true,
      handler () {
        this.getBalance()
      }
    },

    'filters.endDate': {
      immediate: false,
      deep: true,
      handler () {
        this.getBalance()
      }
    }
  },

  created () {
    EventBus.$on('financial-summary-set-filter', (payload) => this.setFilters(payload))
    EventBus.$on('reload-finance', () => this.getBalance())

    this.filters.startDate = this.$moment().subtract(1, 'M')
    this.filters.endDate = this.$moment()

    this.getBalance()
  },

  destroyed () {
    this.balance.expenses = 0
    this.balance.foreseen = 0
    this.balance.revenue = 0
  },

  methods: {
    getBalance () {
      const url = `${this.prefix}/financial_statement/balance?${this.sufix}`

      this.loading = true
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const { data } = res

          this.balance.expenses = parseFloat(data.expenses) || 0
          this.balance.foreseen = parseFloat(data.expectedRevenue) || 0
          this.balance.revenue = parseFloat(data.realizedRevenue) || 0
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false))
    },

    setFilters (data) {
      if (data) {
        const oldDate = this.$moment(this.filters[data.type])
        const newDate = this.$moment(data.value)

        if (!newDate.isSame(oldDate, 'd')) {
          this.filters[data.type] = newDate
        }
      }
    }
  }
}
</script>
